<template>
    <a href="https://plotfactory.com" target="_blank" class="anchor-wrap d-block">
        <v-layout class="pf-branding" row justify-center @click="clicked">
            <v-flex shrink class="pr-2">
                <img src="../../../images/plot-factory-icon-black.png" alt class="pf-icon">
            </v-flex>
            <v-flex shrink class="pl-2 pf-branding-copy" align-self-center>
                <span class="pf-powered-by">powered by</span>
                <br>
                <strong class="pf-main-link black--text">PlotFactory.com</strong>
                <br>
                <span class="black--text">Craft Your Universe</span>
            </v-flex>
        </v-layout>
    </a>
</template>

<script>
export default {
    methods: {
        clicked() {
            this.$ga.event('Preview', 'click', 'Clicked branding link', 1)
        }
    }
}
</script>

<style lang="scss">
.anchor-wrap {
    text-decoration: none;
}

.pf-branding {
    font-family: "Montserrat", "Arial", sans-serif;
}

.pf-icon {
    height: 90px;
}

.pf-branding-copy {
    line-height: 1.2;
}

.pf-powered-by {
    color: #6c757d;
}

.pf-main-link {
    font-size: 30px;
    font-weight: 400;
}
</style>